import { UiKit } from '@datavant/uikit';
import { DebugMenu } from './debug/DebugMenu';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { TOP_NAV_HEIGHT } from '@datavant/idsb-shared/components/size';
import useUser from '../lib/useUser';
import { UserDropdown } from './UserDropdown';
import { RequestManagerTopNavItems } from './RequestManagerTopNavItems';
import logo from '../public/new-logo-white.png';
import { shouldUseNewBranding } from '../themes/utils';

export const TopNav = (): JSX.Element => {
    const currentUser = useUser();
    return (
        <UiKit.Chakra.HStack
            h={`${TOP_NAV_HEIGHT}px`}
            w={'100%'}
            position={'fixed'}
            top={0}
            left={0}
            right={0}
            justify={'flex-end'}
            p={`0 ${UiKit.consistency.buffer}`}
            zIndex={10000}
            background={'linear-gradient(rgb(0, 36, 82), rgb(10, 46, 92))'}
            spacing={UiKit.consistency.buffer}
        >
            {currentUser.user && currentUser.user.isTrueDatavanter && <DebugMenu />}
            {currentUser.user && <UserDropdown />}
            <RequestManagerTopNavItems />
        </UiKit.Chakra.HStack>
    );
};

export const OneDatavantTopNav = (): JSX.Element => {
    const currentUser = useUser();
    return (
        <UiKit.Chakra.HStack
            h={`${TOP_NAV_HEIGHT}px`}
            w="100%"
            position="fixed"
            top={0}
            left={0}
            right={0}
            justify="space-between"
            p={`0 ${UiKit.consistency.buffer}`}
            zIndex={10000}
            background={UiKit.consistency.brandColors.sideNav.background}
            spacing={UiKit.consistency.buffer}
        >
            <Image src={logo} alt="Datavant" width="130" height="24" />
            <UiKit.Chakra.HStack spacing={UiKit.consistency.buffer}>
                {currentUser.user && currentUser.user.isTrueDatavanter && <DebugMenu />}
                {currentUser.user && <UserDropdown />}
                <RequestManagerTopNavItems />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.HStack>
    );
};
export const WrappedTopNav = (): JSX.Element => {
    const [useNewBranding, setUseNewBranding] = useState<boolean>(true);

    useEffect(() => {
        setUseNewBranding(shouldUseNewBranding());
    }, []);

    return useNewBranding ? <OneDatavantTopNav /> : <TopNav />;
};
